import { useEffect, useRef, useState } from 'react';
import type { Registratie } from '@/types/domain';
import { getConfig } from '@/config/appConfig';
import { draftService } from '@/services/draftService';

/**
 * Slaat het formulier automatisch op als concept in localStorage.
 * Debounced, zodat typen niet elke toetsaanslag naar de opslag schrijft.
 *
 * @param registratie  de huidige formulierstaat
 * @param actief       uit zetten zodra het formulier definitief is opgeslagen
 * @returns tijdstip van de laatste conceptopslag (ISO) of null
 */
export function useAutosave(registratie: Registratie | null, actief: boolean): string | null {
  const [laatsteOpslag, setLaatsteOpslag] = useState<string | null>(null);
  const eersteRender = useRef(true);

  useEffect(() => {
    if (!registratie || !actief) return;

    // De eerste render is alleen het inladen; dat is geen wijziging.
    if (eersteRender.current) {
      eersteRender.current = false;
      return;
    }

    const timer = setTimeout(() => {
      setLaatsteOpslag(draftService.bewaar(registratie));
    }, getConfig().autosaveIntervalMs);

    return () => clearTimeout(timer);
  }, [registratie, actief]);

  // Nieuw formulier geopend: teller resetten.
  useEffect(() => {
    eersteRender.current = true;
    setLaatsteOpslag(null);
  }, [registratie?.id]);

  return laatsteOpslag;
}
